// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../graphql/api/index';

import { BlogPostPreviewFragmentDoc } from '../../components/cms/component/blog/BlogPostPreview.generated';
import { ImageLargeFragmentDoc } from '../../components/cms/imageLarge.fragment.generated';
import { ImageCommonFragmentDoc } from '../../components/cms/imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from '../../components/cms/imageSize.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const BlogAuthorDocument = `
    query blogAuthor($slug: String!, $page: Int!, $limit: Int!, $locale: Locale!) {
  collection: authorBySlug(slug: $slug, locale: $locale) {
    id
    name
    posts(page: $page, limit: $limit, locale: $locale) {
      ...blogPostPreview
    }
    postAggregation(locale: $locale) {
      count
    }
  }
}
    ${BlogPostPreviewFragmentDoc}
${ImageLargeFragmentDoc}
${ImageCommonFragmentDoc}
${ImageSizeFragmentDoc}`;

export function useBlogAuthorQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.BlogAuthorQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.BlogAuthorQuery, SchemaTypes.BlogAuthorQueryVariables | undefined>({ query: BlogAuthorDocument, variables: undefined, ...options });
};